import { httpRequest } from '@common/util/api-common.util';

class FishAPI {
  static cancelamentoFish(laudo, justificativa) {
    return httpRequest(`laudos/${laudo}/etapas/fish/cancelamento`, 'PATCH', {
      justificativa: justificativa,
    }).then((json) => json.data);
  }
}

export default FishAPI;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/fish/fish.api.js